/* eslint-disable no-alert */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  Tooltip,
  IconButton,
  FormControlLabel,
  makeStyles,
  Typography,
  ListItem,
  ListItemText,
  TableContainer,
  Table, TableBody,
  TableRow,
  TableCell,
  FormControl,
  InputLabel,
  MenuItem,
  Box,
  Select,
  Menu,
  CircularProgress,
} from '@material-ui/core';
import { TableHead } from '@aws-amplify/ui-react';
import PropTypes from 'prop-types';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import PauseIcon from '@material-ui/icons/Pause';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import {
  React, useEffect, useState, useMemo,
} from 'react';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import InfoIcon from '@material-ui/icons/Info';
import { Doughnut, Bar } from 'react-chartjs-2';
import moment from 'moment';
import SummaryIcon from '@material-ui/icons/Assessment';
import { useHistory } from 'react-router-dom'; // Assuming you're using react-router
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import DeleteIcon from '@material-ui/icons/Delete';
import { useQuery, useQueries } from '@tanstack/react-query';
import GraphqlService from '../../service/graphqlService';
import { ReactComponent as GlobalDeploymentIcon } from '../../assets/ic_global_deployment.svg';
import { ReactComponent as RegexIcon } from '../../assets/ic_regex.svg';
import { ReactComponent as MarketIcon } from '../../assets/ic_market.svg';
import {
  formatToPrintableDate,
} from '../../utils/dateUtils';
import { downloadFile } from '../../utils/exportUtils';
import {
  CSV_FILETYPE, DELETE_DEPLOY_PERMISSION, TOOLTIP_GLOBAL_DEPLOYMENT, TOOLTIP_REGEX_DEPLOYMENT,
  TOOLTIP_MARKET_DEPLOYMENT, TOOLTIP_DEVICE_DEPLOYMENT, TOOLTIP_DEVICE_DEPLOYMENT_CSV,
} from '../../utils/constants';
import Restricted from '../../authorization/Restricted';
import { useSnackbar } from '../../providers/SnackbarContext';
import { useProject } from '../../config/ProjectContext';
import JsonPopup from '../JsonPopup';
import LoadingAnimation from '../LoadingAnimation';
import EditableInput from '../EditableInput';
import isStringifiedObject from '../../utils/isStringifiedObject';
import useGetDevicesNotAllowed from '../../hooks/useGetDevicesNotAllowed';
import useAnalytics from '../../hooks/useAnalytics';
import useRegionFeatureGate from '../../hooks/useRegionFeatureGate';
import StagedWaveDetails from './StagedWaveDetails';
import UnreachableBadge from '../DeploymentList/UnreachableBadge';
import UnreachableTooltip from '../DeploymentList/UnreachableTooltip';
import {
  OVERALL_STATUS_SOURCE, buildOverallStatusFromCounts, buildLifecycleCounts,
} from '../../utils/overallStatusSource';

const useStyles = makeStyles((theme) => ({
  rootDetail: {
    flexGrow: 1,
    background: '#E2E2E2',
    height: '100%',
    with: '100%',
  },
  statusBullet: {
    display: 'inline-block',
    width: '10px',
    height: '10px',
    borderRadius: '50%',
    marginRight: '5px',
  },
  detailItem: {
    borderRadius: '8px 0px 0px 8px',
    background: '#fff',
  },
  detailInfoItem: {
    padding: 10,
  },
  detailInsight: {
    borderRadius: '0px 8px 8px 0px',
    padding: 8,
  },
  infoSection: {
    textAlign: 'left',
    height: '100%',
    borderRadius: 8,
    padding: 12,
  },
  headerDetailTitle: {
    paddingBottom: theme.spacing(2),
    fontWeight: 'bold',
  },
  infoValue: {
    marginBottom: theme.spacing(1),
  },
  headerValue: {
    fontWeight: 'bold',
  },

  details: {
    padding: 0,
  },
  cardTitle: {
    fontSize: 16,
    whiteSpace: 'normal',
    wordBreak: 'break-word',
  },
  cardContent: {
    backgroundColor: '#fff',
    color: theme.palette.primary.text,
    flexGrow: 1,
  },
  detailsTitle: {
    fontSize: 14,
    paddingRight: '8px',
  },
  accordionContainer: {
    marginLeft: 24,
    marginRight: 24,
    borderRadius: '0px',
  },
  root: {
    padding: 0,
    backgroundColor: '#fff',
    marginBottom: 4,
    marginTop: 4,
    borderRadius: '0px',
  },
  summaryRoot: {
    backgroundColor: '#fff',
    borderRadius: '0px',
    margin: 0,
    overflow: 'hidden',
  },
  accordionContent: {
    margin: -12,
    overflow: 'hidden',
  },
  headingTitle: {
    fontSize: 16,
    fontWeight: theme.typography.fontWeightMedium,
  },
  mainDetailTitle: {
    padding: theme.spacing(2),
    fontWeight: 'bold',
  },
  headingTitleElements: {
    fontWeight: theme.typography.h6.fontWeight,
    fontFamily: theme.typography.h5.fontFamily,
    lineHeight: theme.typography.h5.lineHeight,
    letterSpacing: theme.typography.h5.letterSpacing,
    fontSize: theme.typography.h5.fontSize,
    color: theme.palette.primary.text,
  },
  headingDescription: {
    fontSize: 14,
    fontWeight: theme.typography.fontWeightRegular,
    color: theme.palette.secondary.text,
  },
  headingDate: {
    fontSize: 14,
    fontWeight: theme.typography.fontWeightRegular,
    color: theme.palette.primary.text,
  },
  headingDeletedDate: {
    fontSize: 14,
    fontWeight: theme.typography.fontWeightRegular,
    color: 'red',
  },
  detailsText: {
    fontSize: 14,
    fontWeight: theme.typography.fontWeightRegular,
    color: theme.palette.secondary.text,
  },
  iconsBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 0,
  },
  icon: {
    color: theme.palette.primary.text,
  },
  block: {
    background: theme.palette.background.default,

  },
  blockTitle: {
    fontSize: 16,
    fontWeight: 500,

  },
  key: {
    color: theme.palette.primary.subMain,
    whiteSpace: 'nowrap',
  },
  cardHeader: {
    padding: 10,
  },
  tableBodyDetailItem: {
    height: '100%',
    background: '#fff',
  },
  tableHeadDetailItem: {
    background: '#F2F2F2',
  },
  tableHead: {
    fontWeight: 'bold',
  },
  bodyValue: {
    whiteSpace: 'normal',
    wordBreak: 'break-word',
  },
  overallContainer: {
    background: '#E2E2E2',
    padding: 10,
  },
  overallRootContainer: {
    marginBottom: 32,
  },
  infoItems: {
    marginBottom: 6,
  },
  deployHeaderItem: {
    marginBottom: 16,
  },
  tableStatus: {
    margin: 8,
    borderRadius: 8,
  },
  insightContainer: {
    width: '100%',
    height: '100%',
    maxWidth: 350,
    maxHeight: 350,
    alignContent: 'center',
    alignItems: 'center',
  },
  detailSerialFilterStyle: {
    width: '100%',
    minWidth: 250,

  },
  detailStatusFilterStyle: {
    width: '100%',
    minWidth: 190,
    marginTop: 6,
    paddingRight: 12,
  },
  deleteWave: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
  },
  developmentTypeIcons: {
    alignSelf: 'flex-start',
  },
  downloadCloud: {
    padding: 0,

  },
  globalDeployIcon: {
    marginTop: 4,
  },
  gridChartProgress: {
    marginTop: 16,
    marginLeft: 16,
  },
  jsonCopyButton: {
    backgroundColor: theme.palette.primary.button,
    color: theme.palette.common.white,
    padding: '8px 16px',
    borderRadius: 12,
    '& :disabled': {
      color: theme.palette.primary.light,
    },
  },
  loadingContainer: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: 42,
  },
  descriptionElements: {
    width: '100%',
    marginTop: -16,
    marginBottom: -12,
  },
  sourceToggleContainer: {
    border: '1px solid #ccc',
    borderRadius: 16,
    overflow: 'hidden',
    marginRight: 8,
  },
  sourceToggleButton: {
    border: 'none',
    background: 'transparent',
    padding: '4px 10px',
    fontSize: 12,
    cursor: 'pointer',
    color: theme.palette.text.secondary,
  },
  sourceToggleButtonActive: {
    background: theme.palette.primary.main,
    color: theme.palette.common.white,
  },
  sourceToggleButtonDisabled: {
    cursor: 'not-allowed',
    opacity: 0.5,
  },
}));

const barChartOptions = {
  responsive: true,
  scales: {
    x: {
      stacked: true,
      maxBarThickness: 5,
    },
    y: {
      stacked: true,
    },
  },
};

export default function WaveAccordion({
  wave, id, deleted, deleteWave, expandedProp, onExpand, onWaveUpdate,
}) {
  const history = useHistory();
  const classes = useStyles();
  const { project } = useProject();
  const openSnackBar = useSnackbar();

  const [overallStatus, setOverallStatus] = useState([]);
  const [overallStatusSource, setOverallStatusSource] = useState(OVERALL_STATUS_SOURCE.FOTA_LIFECYCLE);
  const [expanded, setExpanded] = useState(expandedProp || false);
  const [selectedDeployment, setSelectedDeployment] = useState('');
  const [deploymentDetails, setDeploymentDetails] = useState([]);
  const [barChartData, setBarChartData] = useState(null);
  const [userDescriptionValue, setUserDescriptionValue] = useState('');
  const [waveDescription, setWaveDescription] = useState(wave?.waveDescription || {});
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [isPausing, setIsPausing] = useState(false);
  const [wavePaused, setWavePaused] = useState(wave?.wavePaused || false);

  // Whether this wave is a bundle (multiple deploys) - needed by the wave-level KPI aggregation below.
  const isBundle = wave.deploys?.length > 1;

  const parsedWaveTarget = (() => {
    try {
      const parsed = JSON.parse(wave.target);
      return Array.isArray(parsed) ? parsed : [parsed];
    } catch (e) {
      return [wave.target];
    }
  })();

  const { setAnalytics } = useAnalytics();

  const isFeatureAvailable = useRegionFeatureGate();

  const { areAllowed: devicesNotAllowed } = useGetDevicesNotAllowed(parsedWaveTarget);

  function printNumberOfTargets(target) {
    try {
      if (target) {
        if (isStringifiedObject(target)) {
          const parsedTarget = JSON.parse(target);
          if (Array.isArray(parsedTarget)) {
            return parsedTarget?.length;
          }
        } else {
          return 1;
        }
      }
      return 1;
    } catch (e) {
      return '*';
    }
  }
  const handleNavigate = (url) => {
    if (selectedDeployment?.deployID && wave?.dateTime && project?.code) {
      const unixDate = moment(wave.dateTime).unix();
      const newUrl = history.createHref({ pathname: `${url}/${project.code}/${selectedDeployment?.deployID}/${unixDate}` });
      window.open(newUrl, '_blank'); // Opens in a new tab
    }
  };

  function convertToCSV(rows) {
    let header = '';
    // eslint-disable-next-line no-return-assign
    Object.keys(rows[0]).map((pr) => (header += `${pr};`));

    let str = '';
    rows.forEach((row) => {
      str += `${row}\r\n`;
    });
    return `${str}`;
  }

  function exportTargetToCSV() {
    try {
      let target = JSON.parse(wave.target);
      // for some projects the target field that arrives from AssetDeploy API is not an array
      // in these cases we will transform to an array
      if (typeof target === 'string') {
        target = [target];
      }

      if (Array.isArray(target)) {
        // Add header
        target.unshift('serials');

        const csv = convertToCSV(target);

        const exportedFilename = `Wave${selectedDeployment?.deployID}_deploymentSerials`;

        downloadFile(csv, exportedFilename, CSV_FILETYPE);
      } else {
        window.alert('Couldn\'t export serials', 'Could not parse serials into .csv');
      }
    } catch (e) {
      window.alert('Couldn\'t export serials', 'There was an error exporting the serials into .csv');
    }
  }

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      openSnackBar('Value copied successfully to the clipboad!', 'success');
    }).catch((err) => {
      openSnackBar('Failed to copy text to clipboard', err);
    });
  };

  const openAsset = (fileId) => {
    const url = `${window.location.origin}/#/assetDetail/${fileId}`;
    window.open(url, '_blank');
  };

  const handleMenuClick = (event) => {
    event.stopPropagation();
    setMenuAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
  };

  const handlePauseToggle = async () => {
    handleMenuClose();
    try {
      setIsPausing(true);
      const newPausedState = !wavePaused;
      
      await GraphqlService.updateWave(
        project.code,
        wave.waveID,
        undefined, // waveDescription
        newPausedState // wavePaused
      );
      
      setWavePaused(newPausedState);
      openSnackBar(
        `Wave ${newPausedState ? 'paused' : 'resumed'} successfully`,
        'success'
      );
      
      // Call onWaveUpdate if provided to refresh the list
      if (onWaveUpdate) {
        onWaveUpdate();
      }
    } catch (error) {
      console.error('Error toggling wave pause state:', error);
      openSnackBar(
        `Failed to ${wavePaused ? 'resume' : 'pause'} wave: ${error.message}`,
        'error'
      );
    } finally {
      setIsPausing(false);
    }
  };

  const handleDelete = () => {
    handleMenuClose();
    if (deleteWave) {
      deleteWave(wave.waveID);
    }
  };

  const statusColors = {
    Done: 'green',
    Error: 'red',
    Executing: 'orange',
  };

  async function searchDeploymentDetails({
    startDate, deployId, params,
  }) {
    const response = await GraphqlService.getLifeCycleObject(
      project.code, `machinecount/${project.code}/${deployId}`, JSON.stringify(params), '', startDate, undefined, undefined,
    );

    if (response) {
      const generalData = JSON.parse(response.data);
      return generalData;
    }
    return [];
  }

  const enable = expanded && !!selectedDeployment?.deployID;

  // Fetch full deployment data when a specific deployment is selected
  const {
    data: fullDeploymentData,
    isFetching: isFetchingFullDeployment,
  } = useQuery({
    queryKey: ['getDeployment', selectedDeployment?.deployID, project.code],
    queryFn: async () => {
      if (!selectedDeployment?.deployID) return null;
      return GraphqlService.getDeployment({
        projectId: Number(project.code),
        deploymentID: selectedDeployment.deployID,
      });
    },
    enabled: enable,
    refetchOnWindowFocus: false,
    staleTime: 30000,
  });

  const fetchDeploymentDetails = async ({ deployId, isError, groupBy }) => {
    if (!deployId) return null;

    return searchDeploymentDetails({
      startDate: moment(wave.dateTime),
      deployId,
      params: { isError, groupBy },
    });
  };

  // Fetch machine count KPIs for the selected deployment
  const {
    data: machineCountKpis,
    isFetching: isFetchingMachineCountKpis,
  } = useQuery({
    queryKey: ['machineCountKpis', selectedDeployment?.deployID, expanded, project?.code],
    queryFn: async () => {
      const result = await GraphqlService.getMachineCountKpis({
        projectId: project.code,
        deployId: selectedDeployment?.deployID,
        sync: 'true',
      });
      return result;
    },
    enabled: expanded && !!project?.code && !!selectedDeployment?.deployID && isFeatureAvailable('machineKpis'),
    refetchOnWindowFocus: false,
    staleTime: 30000,
  });

  // Fetch KPIs for every deploy in a bundle wave (no specific deployment selected), one query per
  // deploy, reusing the same queryKey shape as the single-deployment query above so the cache is
  // shared instead of duplicated when a deploy is later selected individually.
  const waveKpiQueries = useQueries({
    queries: (wave.deploys || []).map((deploy) => ({
      queryKey: ['machineCountKpis', deploy.deployID, expanded, project?.code],
      queryFn: async () => GraphqlService.getMachineCountKpis({
        projectId: project.code,
        deployId: deploy.deployID,
        sync: 'true',
      }),
      enabled: expanded && isBundle && !selectedDeployment && !!project?.code && isFeatureAvailable('machineKpis'),
      refetchOnWindowFocus: false,
      staleTime: 30000,
    })),
  });

  const allKpiSettled = waveKpiQueries.length > 0 && waveKpiQueries.every((q) => q.isSuccess || q.isError);
  // Stable (value-compared) signal so the useMemo below only recomputes - and only produces a new
  // object reference - when the underlying query results actually change, not on every render.
  const kpiSignal = waveKpiQueries
    .map((q) => `${q.status}:${q.data?.validData?.installed || 0}:${q.data?.validData?.inProgress || 0}:${q.data?.validData?.error || 0}`)
    .join('|');
  const waveKpiCounts = useMemo(() => waveKpiQueries
    .filter((q) => q.isSuccess)
    .reduce((acc, q) => ({
      done: acc.done + (q.data?.validData?.installed || 0),
      executing: acc.executing + (q.data?.validData?.inProgress || 0),
      error: acc.error + (q.data?.validData?.error || 0),
    }), { done: 0, executing: 0, error: 0 }),
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [kpiSignal]);

  // Sum FOTA Lifecycle counts across every deploy in the wave (deploymentDetails is already
  // fetched for all deploys on expand - no new fetch needed, see fetchAllDeploymentDetails below).
  // Memoized on `deploymentDetails` (stable reference between renders unless refetched) so this
  // doesn't produce a new object on every render and retrigger the overall-status effect below.
  const waveLifecycleCounts = useMemo(() => (deploymentDetails || []).reduce((acc, deployment) => {
    const counts = buildLifecycleCounts({ successData: deployment?.successData, errorData: deployment?.errorData });
    return {
      done: acc.done + counts.done,
      executing: acc.executing + counts.executing,
      error: acc.error + counts.error,
    };
  }, { done: 0, executing: 0, error: 0 }), [deploymentDetails]);

  // Fetch machine list KPIs for the selected deployment (for potential future use)
  const {
    data: machineListKpis,
    isFetching: isFetchingMachineListKpis,
  } = useQuery({
    queryKey: ['machineListKpis', selectedDeployment?.deployID, expanded, project?.code],
    queryFn: async () => {
      const result = await GraphqlService.getMachineListKpis({
        projectId: project.code,
        deployId: selectedDeployment?.deployID,
        sync: 'true',
        page_size: 10,
        page: 0,
      });
      return result;
    },
    enabled: expanded && !!project?.code && !!selectedDeployment?.deployID && isFeatureAvailable('machineKpis'),
    refetchOnWindowFocus: false,
    staleTime: 30000,
  });

  // selectedDeployment when loading first time if waves just contain one deploy is selected by default
  useEffect(() => {
    if (wave.deploys?.length === 1) {
      setSelectedDeployment(wave.deploys[0]);
    } else {
      setSelectedDeployment(null);
    }
  }, [wave.deploys]);

  // Update wavePaused state when wave prop changes
  useEffect(() => {
    setWavePaused(wave?.wavePaused || false);
  }, [wave?.wavePaused]);

  useEffect(() => {
    if (expanded && wave.deploys?.length > 0) {
      const fetchAllDeploymentDetails = async () => {
        const promises = wave.deploys?.map(async (deploy) => {
          const dataRaw = await fetchDeploymentDetails({ deployId: deploy.deployID, groupBy: 'asset_exit_code' });

          const dataRawSplitted = dataRaw?.validData?.reduce((acc, item) => {
            const key = Object.keys(item)[0];
            const value = item[key];
            if (parseInt(key, 10) >= 0) {
              acc.positives.push(...value);
            } else {
              acc.negatives.push(...value);
            }
            return acc;
          }, { positives: [], negatives: [] });

          return {
            deployID: deploy.deployID,
            file: deploy.file,
            successData: dataRawSplitted.positives,
            errorData: dataRawSplitted.negatives,
          };
        });
        const results = await Promise.all(promises);
        setDeploymentDetails(results);
      };

      fetchAllDeploymentDetails();
    }
  }, [expanded, wave.deploys]);

  // Build the per-deploy Bar chart from the selected source (FOTA Lifecycle or KPI), so it
  // reacts to the same toggle as the aggregate widget.
  useEffect(() => {
    const useKpi = overallStatusSource === OVERALL_STATUS_SOURCE.KPI;
    const ready = useKpi ? allKpiSettled : (deploymentDetails?.length || 0) > 0;

    if (!ready) {
      setBarChartData(null);
      return;
    }

    const perDeploy = (wave.deploys || []).map((deploy, index) => {
      if (useKpi) {
        const query = waveKpiQueries[index];
        const data = query?.isSuccess ? query.data?.validData : null;
        return {
          file: deploy.file,
          doneCount: data?.installed || 0,
          executingCount: data?.inProgress || 0,
          errorCount: data?.error || 0,
        };
      }

      const deployment = deploymentDetails?.find((item) => item.deployID === deploy.deployID);
      const counts = buildLifecycleCounts({ successData: deployment?.successData, errorData: deployment?.errorData });
      return {
        file: deploy.file,
        doneCount: counts.done,
        executingCount: counts.executing,
        errorCount: counts.error,
      };
    });

    // Sort by total machines in descending order (highest on the left)
    const sorted = [...perDeploy].sort((a, b) => (
      (b.doneCount + b.executingCount + b.errorCount) - (a.doneCount + a.executingCount + a.errorCount)
    ));

    const labels = sorted.map((deployment) => `${deployment.file?.type} ${deployment.file?.assetDescription?.version}`);

    setBarChartData({
      labels,
      datasets: [
        {
          label: 'Done',
          data: sorted.map((deployment) => deployment.doneCount),
          backgroundColor: 'green',
          borderWidth: 1,
          barPercentage: 0.5,
          categoryPercentage: 0.5,
        },
        {
          label: 'In progress',
          data: sorted.map((deployment) => deployment.executingCount),
          backgroundColor: 'orange',
          borderWidth: 1,
          barPercentage: 0.5,
          categoryPercentage: 0.5,
        },
        {
          label: 'Error',
          data: sorted.map((deployment) => deployment.errorCount),
          backgroundColor: 'red',
          borderWidth: 1,
          barPercentage: 0.5,
          categoryPercentage: 0.5,
        },
      ],
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deploymentDetails, overallStatusSource, wave.deploys, kpiSignal, allKpiSettled]);

  // Compute overall status from the selected data source (FOTA Lifecycle or KPI)
  useEffect(() => {
    if (!selectedDeployment) {
      if (!isBundle) {
        return;
      }

      // Bundle wave with no specific deployment selected: aggregate across all deploys (User Story 3).
      const lifecycleReady = (deploymentDetails?.length || 0) > 0;
      const kpiReady = allKpiSettled;

      const computeFromLifecycle = () => buildOverallStatusFromCounts(waveLifecycleCounts);
      const computeFromKpi = () => buildOverallStatusFromCounts(waveKpiCounts);

      if (overallStatusSource === OVERALL_STATUS_SOURCE.KPI) {
        setOverallStatus(kpiReady ? computeFromKpi() : []);
        return;
      }

      if (overallStatusSource === OVERALL_STATUS_SOURCE.FOTA_LIFECYCLE) {
        setOverallStatus(lifecycleReady ? computeFromLifecycle() : []);
        return;
      }

      if (!isFeatureAvailable('machineKpis')) {
        setOverallStatus(lifecycleReady ? computeFromLifecycle() : []);
        return;
      }

      if (kpiReady) {
        setOverallStatus(computeFromKpi());
        return;
      }

      setOverallStatus(lifecycleReady ? computeFromLifecycle() : []);
      return;
    }

    const lifecycleEntry = deploymentDetails?.find((item) => item.deployID === selectedDeployment.deployID);
    const lifecycleReady = !!lifecycleEntry;
    const kpiReady = !!machineCountKpis?.validData;

    const computeFromLifecycle = () => buildOverallStatusFromCounts(buildLifecycleCounts({
      successData: lifecycleEntry?.successData,
      errorData: lifecycleEntry?.errorData,
    }));

    const computeFromKpi = () => buildOverallStatusFromCounts({
      done: machineCountKpis?.validData?.installed || 0,
      executing: machineCountKpis?.validData?.inProgress || 0,
      error: machineCountKpis?.validData?.error || 0,
    });

    if (overallStatusSource === OVERALL_STATUS_SOURCE.KPI) {
      setOverallStatus(kpiReady ? computeFromKpi() : []);
      return;
    }

    if (overallStatusSource === OVERALL_STATUS_SOURCE.FOTA_LIFECYCLE) {
      setOverallStatus(lifecycleReady ? computeFromLifecycle() : []);
      return;
    }

    // overallStatusSource === null: preserve today's default behavior
    // (prefer KPI, fall back to lifecycle), except when the KPI feature is
    // unavailable for this project, in which case FOTA Lifecycle is the
    // effective default (User Story 2).
    if (!isFeatureAvailable('machineKpis')) {
      setOverallStatus(lifecycleReady ? computeFromLifecycle() : []);
      return;
    }

    if (kpiReady) {
      setOverallStatus(computeFromKpi());
      return;
    }

    setOverallStatus(lifecycleReady ? computeFromLifecycle() : []);
  }, [
    selectedDeployment, deploymentDetails, machineCountKpis, overallStatusSource, isFeatureAvailable,
    isBundle, waveLifecycleCounts, waveKpiCounts, allKpiSettled,
  ]);

  const doughnutOptions = {
    plugins: {
      tooltip: {
        enabled: false,
      },
    },
    cutout: '70%',
    responsive: true,
  };

  const hasInsight = Array.isArray(overallStatus?.chartData?.datasets?.[0]?.data)
    && overallStatus.chartData.datasets[0].data.some((v) => v > 0);

  // For bundle waves with no deployment selected, the Bar chart below has its own loading
  // indicator; don't also gate the header on `overallStatus` readiness or two loading
  // indicators would show at once.
  const showHeaderLoading = !(isBundle && !selectedDeployment) && !overallStatus?.statusInfo?.length;

  // Handle change function
  const handleChange = (event) => {
    const deployID = event.target.value;
    if (deployID === '') {
      setSelectedDeployment(null); // Reset to wave details if no deployID selected
    } else {
      setSelectedDeployment(wave.deploys.find((deploy) => deploy.deployID === deployID));
    }
  };

  if (!wave || !statusColors) {
    return null;
  }

  const getTargetValue = (target) => {
    if (isStringifiedObject(target)) {
      return JSON.parse(target);
    }
    return target;
  };

  const getJsonObject = () => {
    if (typeof selectedDeployment === 'object' && selectedDeployment !== null) {
      return {
        waveID: wave.waveID,
        targetMarket: getTargetValue(wave.targetMarket),
        excludeMarket: wave.excludeMarket,
        target: getTargetValue(wave.target),
        targetRegex: wave.targetRegex,
        excludeRegex: wave.excludeRegex,
        ...selectedDeployment,
      };
    }
    if (typeof wave === 'object' && wave !== null) return wave;
    return null;
  };

  async function handleDescriptionChange(description) {
    return GraphqlService.updateWave(project.code, wave.waveID, description);
  }

  const handleInputChange = (description) => {
    handleDescriptionChange(JSON.stringify(description))
      .then((res) => {
        setUserDescriptionValue(description.userDescription);
        // update Version-deployment-accordion-detail
        setWaveDescription(description);

        openSnackBar('Wave description updated successfully!', 'success');
      })
      .catch((err) => {
        openSnackBar(`An error occurred while updating the Wave description. Error: ${err} `, 'error');
      });
  };

  const openDeployment = (deploymentID) => {
    const url = `${window.location.origin}/#/deploymentDetail/${deploymentID}`;
    window.open(url, '_blank');
  };

  // Analytics: button_clicked helpers
  const handleDownloadClick = () => {
    setAnalytics({
      event: 'button_clicked',
      extraParams: { name: 'asset_management-waves-download' }
    });
  };

  // Llama a onExpand si se expande el acordeón
  const handleExpandClick = () => {
    setAnalytics({
      event: 'button_clicked',
      extraParams: { name: 'asset_management-waves-expand' }
    });
    if (onExpand) onExpand();
  };

  return (
    <div className={classes.accordionContainer}>
      <Accordion
        className={classes.root}
        id={`wave-accordion-detail-txt${id}`}
        expanded={expanded}
        TransitionProps={{ unmountOnExit: true }}
        onChange={() => {
          if (!expanded) handleExpandClick();
          setExpanded(!expanded);
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon id={`btnExpand-deployment-accordion-detaill-${id}`} />}
          aria-controls="panel1a-content"
          id={`panel-header-deployment-accordion-detaill-${id}`}
          className={classes.summaryRoot}
          classes={{ content: classes.accordionContent }}
        >
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="flex-start"
            display="flex-start"
            wrap="nowrap"
            style={{ overflow: 'hidden' }}
          >

            {/* Asset type/Bundle title */}
            <Grid item xs={12} sm={2} md={2}>
              <ListItem>
                <ListItemText
                  id={`list-deployment-accordion-detail-${id}`}
                  primary={
                    <Typography variant="caption" color="textSecondary">Asset/Bundle</Typography>
                  }
                  secondary={(
                    <Typography variant="body2" component="div" noWrap>
                      {isBundle ? wave.release?.title || '-' : `${selectedDeployment?.file?.type || '-'} ${selectedDeployment?.file?.assetDescription?.version || ''}`}
                    </Typography>
                  )}
                />
              </ListItem>
            </Grid>

            {/* Description */}
            <Grid item xs={12} sm={2} md={2}>
              <ListItem>
                <ListItemText
                  id={`version-deployment-accordion-detail-${id}`}
                  primary={
                    <Typography variant="caption" color="textSecondary">Description</Typography>
                  }
                  secondary={(
                    <Typography component="div" variant="body2" noWrap>
                      {waveDescription?.userDescription || wave?.waveDescription?.userDescription || wave.deploys[0]?.deployDescription?.userDescription || '-'}
                    </Typography>
                  )}
                />
              </ListItem>
            </Grid>

            {/* dateTime */}
            <Grid item xs={6} sm={2} md={1}>
              <ListItem>
                <ListItemText
                  id={`date-deployment-accordion-detail-${id}`}
                  primary={
                    <Typography variant="caption" color="textSecondary">Date</Typography>
                  }
                  secondary={<Typography variant="body2" noWrap>{formatToPrintableDate(wave.dateTime)}</Typography>}
                />
              </ListItem>
            </Grid>

            {/* Staged */}
            <Grid item xs={6} sm={1} md={1}>
              <ListItem>
                <ListItemText
                  id={`${id}Staged`}
                  primary={
                    <Typography variant="caption" color="textSecondary">Staged</Typography>
                  }
                  secondary={
                    <Typography variant="body2" component="div" style={{ display: 'flex', alignItems: 'center' }} noWrap>
                      <span
                        className={classes.statusBullet}
                        style={{ backgroundColor: wave.canaryMetadata ? '#4caf50' : '#9e9e9e' }}
                      />
                      {wave.canaryMetadata ? 'Yes' : 'No'}
                    </Typography>
                  }
                />
              </ListItem>
            </Grid>

            {/* Status */}
            <Grid item xs={6} sm={2} md={1} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <ListItem style={{ justifyContent: 'center', padding: '8px 0' }}>
                <ListItemText
                  id={`status-wave-accordion-detail-${id}`}
                  primary={
                    <Typography variant="caption" color="textSecondary" style={{ textAlign: 'center' }}>Status</Typography>
                  }
                  secondary={
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '4px' }}>
                      {(() => {
                        let status = 'ONGOING';
                        let backgroundColor = '#4caf50'; // Green for ongoing
                        
                        // Check if wave is unreachable (all deployments have deployReachable: false)
                        const deploys = wave?.deploys || [];
                        const isWaveUnreachable = deploys.length > 0 && deploys.every(deploy => deploy.deployReachable === false);
                        
                        if (isWaveUnreachable) {
                          return (
                            <>
                              <UnreachableBadge id={`${id}UnreachableBadge`} />
                              <UnreachableTooltip 
                                id={`${id}UnreachableTooltip`}
                                tooltipText="All deployments in this wave are targeting devices with newer deployments. This wave won't work anymore."
                              />
                            </>
                          );
                        }
                        
                        if (wavePaused === true) {
                          status = 'PAUSED';
                          backgroundColor = '#2196f3'; // Blue for paused
                        } else {
                          status = 'ONGOING';
                          backgroundColor = '#4caf50'; // Green for ongoing
                        }
                        
                        return (
                          <div style={{
                            backgroundColor: backgroundColor,
                            color: 'white',
                            padding: '4px 12px',
                            borderRadius: '12px',
                            fontSize: '12px',
                            fontWeight: 'bold',
                            textAlign: 'center',
                            display: 'inline-block',
                            minWidth: '70px'
                          }}>
                            {status}
                          </div>
                        );
                      })()}
                    </div>
                  }
                />
              </ListItem>
            </Grid>

            {/* Actions Menu */}
            <Grid item xs={6} sm={1} md={1} className={classes.deleteWave}>
              <Grid container display="flex" direction="row" justifyContent="center" alignItems="center">
                {!deleted && devicesNotAllowed !== undefined && (
                  <Restricted to={[DELETE_DEPLOY_PERMISSION]}>
                    <Grid container alignItems="center" justifyContent="center">
                      {devicesNotAllowed?.length > 0 ? (
                        <Tooltip title={`Devices not allowed: ${devicesNotAllowed.join(', ')}`} arrow>
                          <InfoIcon />
                        </Tooltip>
                      ) : (
                        <FormControlLabel
                          aria-label="Actions"
                          onClick={(event) => event.stopPropagation()}
                          onFocus={(event) => event.stopPropagation()}
                          className={classes.iconsBox}
                          control={(
                            <Tooltip title="Actions" arrow>
                              <IconButton
                                size="small"
                                aria-label="actions-menu"
                                id={`ActionsMenu-${id}`}
                                onClick={handleMenuClick}
                                disabled={isPausing}
                              >
                                <MoreVertIcon />
                              </IconButton>
                            </Tooltip>
                          )}
                        />
                      )}
                    </Grid>
                  </Restricted>
                )}

                {/* Menu for actions */}
                {!deleted && (
                  <Menu
                    anchorEl={menuAnchorEl}
                    open={Boolean(menuAnchorEl)}
                    onClose={handleMenuClose}
                    onClick={(event) => event.stopPropagation()}
                  >
                    <MenuItem onClick={handlePauseToggle} disabled={isPausing}>
                      {isPausing ? (
                        <CircularProgress size={20} style={{ marginRight: 8 }} />
                      ) : wavePaused ? (
                        <>
                          <PlayArrowIcon style={{ marginRight: 8 }} />
                          Resume Wave
                        </>
                      ) : (
                        <>
                          <PauseIcon style={{ marginRight: 8 }} />
                          Pause Wave
                        </>
                      )}
                    </MenuItem>
                    <MenuItem onClick={handleDelete}>
                      <DeleteIcon style={{ marginRight: 8 }} />
                      Delete Wave
                    </MenuItem>
                  </Menu>
                )}

              </Grid>
            </Grid>

            {/* Development Types */}
            <Grid item xs={12} sm={2} md={2} className={classes.developmentTypeIcons}>

              <ListItem>
                <ListItemText
                  id={`Development-type-deployment-accordion-detail-${id}`}
                  primary={
                    <Typography variant="caption" color="textSecondary">Deployment Type</Typography>
                  }
                  secondary={(
                    <Grid container display="flex" direction="row" alignItems="center" spacing={1} justifyContent="flex-start">
                      {!wave?.targetRegex && !wave?.targetMarket && wave?.target !== '*' && (
                        <Grid item>
                          <Typography className={classes.headingTitle} id={`${id}NMachines`}>{printNumberOfTargets(wave?.target)}</Typography>
                        </Grid>
                      )}
                      {!wave?.targetRegex && !wave?.targetMarket && wave?.target !== '*' && (

                        <Grid item>
                          <Tooltip title={`${TOOLTIP_DEVICE_DEPLOYMENT}. ${TOOLTIP_DEVICE_DEPLOYMENT_CSV}`} aria-label="download">
                            <IconButton
                              aria-label="download-button"
                              id={`btnDownloadNMachines-deployment-accordion-detail-${id}`}
                              className={classes.downloadCloud}
                              onClick={(event) => {
                                event.stopPropagation();
                                handleDownloadClick();
                                exportTargetToCSV();
                              }}
                              size="small"
                            >
                              <CloudDownloadIcon className={classes.icon} fontSize="small" />
                            </IconButton>
                          </Tooltip>

                        </Grid>
                      )}
                      {((!wave?.targetRegex) && (wave?.targetMarket === '*' || wave?.target === '*')) && (
                        <Grid item className={classes.globalDeployIcon}>
                          <Tooltip title={TOOLTIP_GLOBAL_DEPLOYMENT} aria-label="deployGlobal">
                            <Typography className={classes.headingTitle}>
                              {/* GlobalDeploymentIcon should be replaced with your actual global deployment icon component */}
                              <GlobalDeploymentIcon className={classes.icon} />
                            </Typography>
                          </Tooltip>

                        </Grid>
                      )}

                      {wave?.targetRegex && (
                        <Tooltip title={TOOLTIP_REGEX_DEPLOYMENT} aria-label="deployRegex" className={classes.globalDeployIcon}>
                          <Typography className={classes.headingTitle}>
                            {/* RegexIcon should be replaced with your actual regex deployment icon component */}
                            <RegexIcon className={classes.icon} />
                          </Typography>
                        </Tooltip>
                      )}

                      {!wave?.target && !wave?.targetRegex && wave?.targetMarket && selectedDeployment?.targetMarket !== '*' && (
                        <>
                          <Typography className={classes.headingTitle}>
                            <p className={classes.headingTitleElements}>{printNumberOfTargets(wave?.targetMarket)}</p>
                          </Typography>
                          <Tooltip title={TOOLTIP_MARKET_DEPLOYMENT} aria-label="deployMarket">
                            <IconButton disabled size="small">
                              {/* MarketIcon should be replaced with your actual market deployment icon component */}
                              <MarketIcon className={classes.icon} />
                            </IconButton>
                          </Tooltip>
                        </>
                      )}
                    </Grid>
                  )}
                />
              </ListItem>

            </Grid>

            {/* #Assets */}
            <Grid item xs={6} sm={1} md={1}>
              <ListItem>
                <ListItemText
                  id={`NAssets-deployment-accordion-detail-${id}`}
                  primary={
                    <Typography variant="caption" color="textSecondary">#Assets</Typography>
                  }
                  secondary={<Typography variant="body2">{wave.deploys?.length || 0}</Typography>}
                />
              </ListItem>
            </Grid>

          </Grid>
        </AccordionSummary>

        <AccordionDetails className={classes.details}>
          <Grid container className={classes.rootDetail}>
            <Grid container className={classes.overallRootContainer}>

              {/* Left Side Content */}
              <Grid item xs={12} sm={12} lg={8} className={classes.overallContainer}>
                {
                  /* Doughnut Chart and Deployment Info (single deployment, or bundle aggregate) */
                }
                <Grid container className={classes.detailItem}>
                  {/* Overall Deployment Status Header */}
                  <Grid item xs={12}>
                    {showHeaderLoading ? (
                      <Grid container alignContent="center" justifyContent="center" className={classes.loadingContainer}>
                        <LoadingAnimation title="Loading deployment status" />
                      </Grid>
                    ) : (
                      <Box display="flex" justifyContent="space-between" width="100%">
                        <Typography variant="subtitle1" className={classes.mainDetailTitle}>
                          Overall Deployment Status
                        </Typography>
                        <Box display="flex" alignItems="center">
                          <Box display="flex" alignItems="center" className={classes.sourceToggleContainer}>
                            <button
                              type="button"
                              className={`${classes.sourceToggleButton} ${(overallStatusSource === OVERALL_STATUS_SOURCE.FOTA_LIFECYCLE || (overallStatusSource === null && !isFeatureAvailable('machineKpis'))) ? classes.sourceToggleButtonActive : ''}`}
                              onClick={(event) => {
                                event.stopPropagation(); // Prevents accordion from expanding
                                setOverallStatusSource(OVERALL_STATUS_SOURCE.FOTA_LIFECYCLE);
                                setAnalytics({
                                  event: 'button_clicked',
                                  extraParams: { name: 'asset_management-wave-overall_status_source_toggle' },
                                  });
                                }}
                              >
                                FOTA Lifecycle
                              </button>
                              <button
                                type="button"
                                disabled={!isFeatureAvailable('machineKpis')}
                                className={`${classes.sourceToggleButton} ${(overallStatusSource === OVERALL_STATUS_SOURCE.KPI || (overallStatusSource === null && isFeatureAvailable('machineKpis'))) ? classes.sourceToggleButtonActive : ''} ${!isFeatureAvailable('machineKpis') ? classes.sourceToggleButtonDisabled : ''}`}
                                onClick={(event) => {
                                  event.stopPropagation(); // Prevents accordion from expanding
                                  if (!isFeatureAvailable('machineKpis')) return;
                                  setOverallStatusSource(OVERALL_STATUS_SOURCE.KPI);
                                  setAnalytics({
                                    event: 'button_clicked',
                                    extraParams: { name: 'asset_management-wave-overall_status_source_toggle' },
                                  });
                                }}
                              >
                                KPI
                              </button>
                            </Box>
                            <Tooltip title="View Deployment Details" arrow>
                              <IconButton
                                onClick={(event) => {
                                  event.stopPropagation(); // Prevents accordion from expanding
                                  handleNavigate('/statistics/deploymentDetails');
                                }}
                              >
                                <InfoIcon />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="View Deployment Summary" arrow>
                              <IconButton
                                onClick={(event) => {
                                  event.stopPropagation(); // Prevents accordion from expanding
                                  handleNavigate('/statistics/deploymentStatus');
                                }}
                              >
                                <SummaryIcon />
                              </IconButton>
                            </Tooltip>
                          </Box>
                        </Box>
                      )}
                    </Grid>

                    {/* Deployment Table */}
                    <Grid item xs={12} lg={8}>
                      {selectedDeployment && overallStatus?.statusInfo?.length && (
                        <TableContainer style={{ width: '100%', overflowX: 'auto', padding: '8px' }}>
                          <Table aria-label="simple table">
                            <TableHead>
                              <TableRow>
                                <TableCell>Status</TableCell>
                                <TableCell align="right">Devices</TableCell>
                                <TableCell align="right">Percentage</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {/* Done */}
                              <TableRow key="done" className={classes.tableRow}>

                                <TableCell component="th" scope="row">
                                  {overallStatus?.statusInfo[0].status}
                                  {' '}
                                  <span
                                    className={classes.statusBullet}
                                    style={{ backgroundColor: statusColors.Done }}
                                  />
                                </TableCell>

                                <TableCell align="right">{overallStatus?.statusInfo[0].count}</TableCell>
                                <TableCell align="right">{overallStatus?.statusInfo[0].percentage !== undefined ? `${overallStatus?.statusInfo[0].percentage}%` : ''}</TableCell>
                              </TableRow>

                              {/* Error */}
                              <TableRow key="error" className={classes.tableRow}>

                                {/* Error */}
                                <TableCell component="th" scope="row">
                                  {overallStatus?.statusInfo[1].status}
                                  {' '}
                                  <span
                                    className={classes.statusBullet}
                                    style={{ backgroundColor: statusColors.Error }}
                                  />
                                </TableCell>

                                <TableCell align="right">{overallStatus?.statusInfo[1].count}</TableCell>
                                <TableCell align="right">{overallStatus?.statusInfo[1].percentage !== undefined ? `${overallStatus?.statusInfo[1].percentage}%` : ''}</TableCell>
                              </TableRow>
                              {/* In progress */}
                              <TableRow key="inprogress" className={classes.tableRow}>

                                {/* Executing */}
                                <TableCell component="th" scope="row">
                                  In progress
                                  {' '}
                                  <span
                                    className={classes.statusBullet}
                                    style={{ backgroundColor: statusColors.Executing }}
                                  />

                                  
                                </TableCell>

                                <TableCell align="right">{overallStatus?.statusInfo[2].count}</TableCell>
                                <TableCell align="right">{overallStatus?.statusInfo[2].percentage !== undefined ? `${overallStatus?.statusInfo[2].percentage}%` : ''}</TableCell>
                              </TableRow>
                              {/* Total */}
                              <TableRow key="total" className={classes.tableRow}>

                                {/* Total */}
                                <TableCell component="th" scope="row">
                                  Total
                                  {' '}
                                  

                                </TableCell>

                                <TableCell align="right">{overallStatus?.statusInfo[3].count}</TableCell>
                              </TableRow>

                            </TableBody>
                          </Table>
                        </TableContainer>
                      )}
                    </Grid>

                    {/* Doughnut Chart - single deployment only; the bundle aggregate shows the Bar chart instead */}
                    {selectedDeployment && hasInsight && overallStatus?.chartData && (
                      <Grid item xs={12} lg={4} className={classes.detailInsight}>
                        <div className={classes.insightContainer}>
                          <Doughnut data={overallStatus?.chartData} options={doughnutOptions} />
                        </div>
                      </Grid>
                    )}

                    {/* Per-deploy breakdown (always visible alongside the aggregate, no toggle) */}
                    {isBundle && !selectedDeployment && (
                      <Grid item xs={12} style={{ padding: 26 }}>
                        {barChartData?.labels && barChartData?.labels?.length > 0 && (
                          <Bar data={barChartData} options={barChartOptions} />
                        )}
                        {!barChartData && (
                          <Grid container alignContent="center" justifyContent="center" className={classes.loadingContainer}>
                            <LoadingAnimation title="Loading deployment status" />
                          </Grid>
                        )}
                      </Grid>
                    )}
                  </Grid>
              </Grid>

              {/* Right Side (Info Section) */}
              <Grid item xs={12} sm={12} lg={barChartData?.hasNoValues && isBundle ? 12 : 4} className={classes.detailInfoItem}>
                <Grid className={classes.infoSection}>
                  <Typography variant="subtitle1" className={classes.headerDetailTitle}>
                    Information
                  </Typography>

                  <Grid container>
                    {isBundle && (

                      <FormControl variant="outlined" style={{ width: '100%', marginBottom: 12 }}>
                        <InputLabel>Asset</InputLabel>
                        <Select
                          value={selectedDeployment?.deployID || ''}
                          onChange={handleChange}
                          label="Asset"
                        >
                          <MenuItem value="">
                            <em>Wave details</em>
                          </MenuItem>
                          {wave.deploys.map((deploy) => (
                            <MenuItem key={deploy?.deployID} value={deploy?.deployID}>
                              <Typography variant="body1">{`${deploy.file?.type} ${deploy.file?.assetDescription?.version}`}</Typography>
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>

                    )}
                  </Grid>

                  {/* Wave ID */}
                  <Box display="flex" className={classes.infoItems} alignItems="center">

                    <Box display="flex" flexDirection="column" mb={0}>

                      <Typography variant="body2" className={classes.headerValue} gutterBottom={false}>
                        {selectedDeployment ? 'Deploy ID' : 'Wave ID'}
                      </Typography>

                      <Typography variant="body2" className={classes.bodyValue}>
                        {selectedDeployment?.deployID || wave.waveID}
                      </Typography>

                    </Box>

                    <IconButton onClick={() => copyToClipboard(selectedDeployment?.deployID || wave?.waveID)}>
                      <FileCopyIcon />
                    </IconButton>

                    <IconButton className={classes.detailIcon} onClick={() => openDeployment(selectedDeployment?.deployID)}>
                      <ExitToAppIcon />
                    </IconButton>

                  </Box>

                  {/* Actor */}
                  <Box display="flex" className={classes.infoItems} alignItems="center">

                    <Box display="flex" flexDirection="column" mb={0}>
                      <Typography variant="body2" className={classes.headerValue} gutterBottom={false}>
                        Actor
                      </Typography>
                      <Typography variant="body2" className={classes.bodyValue}>

                        {selectedDeployment ? selectedDeployment.deployDescription?.userName || selectedDeployment.actor : wave.deploys[0].deployDescription?.userName || wave.deploys[0].actor}

                      </Typography>

                    </Box>

                    <IconButton onClick={() => copyToClipboard(wave.deploys[0].deployDescription?.userName || wave.deploys[0].actor)}>
                      <FileCopyIcon />
                    </IconButton>

                  </Box>

                  {/* Wave description */}

                  <div className={classes.infoItems}>
                    <Typography variant="body2" className={classes.headerValue}>
                      Wave Description
                    </Typography>

                    <Box display="flex" flexWrap="wrap" mt={1} mb={1}>
                      {wave?.waveDescription ? Object.entries(wave.waveDescription).map(([key, value]) => (
                        <Box key={key} className={classes.descriptionElements}>
                          <EditableInput
                            label={key}
                            value={value || '-'}
                            onChange={(change) => handleInputChange({ ...wave.waveDescription, [key]: change })}
                            fullWidth
                          />
                        </Box>
                      )) : (
                        <Box key="editableInput" className={classes.descriptionElements}>
                          <EditableInput
                            label="userDescription"
                            value={userDescriptionValue || '-'}
                            onChange={(change) => handleInputChange({ userDescription: change })}
                            fullWidth
                          />
                        </Box>
                      )}
                    </Box>
                  </div>

                  {/* Target */}
                  {wave.targetRegex && (
                    <div className={classes.infoItems}>
                      <Typography variant="body2" className={classes.headerValue}>
                        Target Regex
                      </Typography>
                      <Typography variant="body2" className={classes.infoValue}>
                        {selectedDeployment ? selectedDeployment?.targetRegex : wave.targetRegex}
                      </Typography>
                    </div>
                  )}

                  {/* Target Market */}
                  {wave.targetMarket && (
                    <div className={classes.infoItems}>
                      <Typography variant="body2" className={classes.headerValue}>
                        Target Market
                      </Typography>
                      <Typography variant="body2" className={classes.infoValue}>
                        {selectedDeployment ? selectedDeployment.targetMarket : wave.targetMarket}
                      </Typography>
                    </div>
                  )}

                  {/* Target ExcludeMarket */}
                  {wave.excludeMarket
                    && (
                      <div className={classes.infoItems}>
                        <Typography variant="body2" className={classes.headerValue}>
                          Exclude Market
                        </Typography>
                        <Typography variant="body2" className={classes.infoValue}>
                          {selectedDeployment ? selectedDeployment.excludeMarket : wave.excludeMarket}

                        </Typography>
                      </div>
                    )}

                  {/* Target Exclude */}
                  {wave.exclude && (
                    <div className={classes.infoItems}>
                      <Typography variant="body2" className={classes.headerValue}>
                        Exclude
                      </Typography>
                      <Typography variant="body2" className={classes.infoValue}>
                        {wave.exclude}
                      </Typography>
                    </div>
                  )}

                  {/* Target fileID */}
                  {selectedDeployment?.file?.fileID && (

                    <Box display="flex" className={classes.infoItems} alignItems="center">

                      <Box display="flex" flexDirection="column" mb={0}>
                        <Typography variant="body2" className={classes.headerValue}>
                          Asset
                        </Typography>
                        <Typography variant="body2" className={classes.bodyValue}>
                          Open the associated asset
                        </Typography>

                      </Box>

                      <IconButton aria-label="openAsset" onClick={() => openAsset(selectedDeployment?.file.fileID)}>
                        <OpenInNewIcon />
                      </IconButton>

                    </Box>
                  )}

                  {/* copy all deployment object with json button aligned to right */}
                  <Box display="flex" justifyContent="flex-end">
                    <JsonPopup
                      title="Deployment JSON"
                      jsonObject={getJsonObject()}
                    />
                  </Box>

                </Grid>
              </Grid>

              {/* Wave Stage Details - Always visible when wave has canaryMetadata */}
              {wave.canaryMetadata && (
                <Grid item xs={12}>
                  <StagedWaveDetails 
                    wave={wave}
                    isDeployment={false}
                    onUpdate={() => {
                      // Trigger refetch of wave data
                      onWaveUpdate?.();
                    }}
                  />
                  
                  {/* Deployment Stage Details as substage - Nested inside Wave Stage Details */}
                  {fullDeploymentData?.canaryMetadata && (
                    <div className="ml-8 mt-2">
                      <StagedWaveDetails 
                        wave={fullDeploymentData}
                        isDeployment={true}
                        onUpdate={() => {
                          // Trigger refetch of deployment data
                          onWaveUpdate?.();
                        }}
                      />
                    </div>
                  )}
                </Grid>
              )}

            </Grid>
          </Grid>
        </AccordionDetails>

      </Accordion>
    </div>

  );
}
WaveAccordion.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  wave: PropTypes.any,
  id: PropTypes.string,
  deleted: PropTypes.bool,
  deleteWave: PropTypes.func,
  expandedProp: PropTypes.bool,
  onWaveUpdate: PropTypes.func,
};
WaveAccordion.defaultProps = {
  wave: undefined,
  id: undefined,
  deleted: false,
  deleteWave: undefined,
  expandedProp: false,
  onWaveUpdate: undefined,
};
